import { KEYWORD_GLOSSARY } from './sorceryKeywords';
import { k } from '../../localization/t';

const RAW_ENTRIES = Object.entries(KEYWORD_GLOSSARY).map(([keyword, description]) => {
  const isKeywordAbility = /^Keyword [Aa]bility/.test(description);
  const cleanDescription = isKeywordAbility
    ? description.replace(/^Keyword [Aa]bility\.\s*/, '')
    : description;
  return {
    keyword,
    description: cleanDescription,
    isKeywordAbility,
    searchHaystack: `${keyword}\n${cleanDescription}`.toLowerCase(),
  };
});

const SORTED_ENTRIES = [...RAW_ENTRIES].sort((a, b) =>
  a.keyword.localeCompare(b.keyword, 'en', { sensitivity: 'base' })
);

const BY_KEY = new Map(SORTED_ENTRIES.map((e) => [e.keyword.toLowerCase(), e]));

export const CODEX_FILTERS = [
  { id: 'all', label: k('All') },
  { id: 'keywords', label: k('Keywords') },
  { id: 'shortcuts', label: k('Shortcuts') },
];

export function getCodexEntries(filter = 'all') {
  if (filter === 'keywords') return SORTED_ENTRIES.filter((e) => e.isKeywordAbility);
  return SORTED_ENTRIES;
}

export function searchCodex(query, filter = 'all') {
  const entries = getCodexEntries(filter);
  const q = query.trim().toLowerCase();
  if (!q) return entries;
  const titleHits = [];
  const bodyHits = [];
  for (const entry of entries) {
    if (entry.keyword.toLowerCase().includes(q)) titleHits.push(entry);
    else if (entry.searchHaystack.includes(q)) bodyHits.push(entry);
  }
  return [...titleHits, ...bodyHits];
}

export function getCodexEntry(keyword) {
  if (!keyword) return null;
  return BY_KEY.get(keyword.toLowerCase()) || null;
}

